"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_3 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_4 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_5 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_6 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_7 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_8 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_9 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_10 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const floating_vue_1 = require("floating-vue");
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let TableSummaryTrialsDetails = class TableSummaryTrialsDetails extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.activeTab = '';
        this.toSearch = '';
        this.userHook = 'user';
        this.bmkHook = 'bmk';
        this.pendingHook = 'pending';
        this.hooks = [this.userHook, this.bmkHook, this.pendingHook];
        this.mixpanelHandler = new MixpanelHandler_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    onchangesearch(textSearch) {
        if (!this.hooks.some((h) => h === textSearch)) {
            this.activeTab = '';
        }
        else {
            this.activeTab = textSearch;
        }
        this.$emit('onchangesearch', textSearch);
    }
    switchSelector(sel) {
        if (this.activeTab === sel) {
            this.activeTab = '';
            this.toSearch = '';
        }
        else {
            this.activeTab = sel;
            this.toSearch = '#' + sel;
        }
        this.mixpanelHandler.trackEvent('proposalPresetFilter', {
            filter: sel,
        });
        this.$emit('onchangesearch', this.toSearch);
        this.$emit('activeSelector', sel);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryTrialsDetails.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableSummaryTrialsDetails.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableSummaryTrialsDetails.prototype, "subtitle", void 0);
TableSummaryTrialsDetails = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TableSummary: bmk_ui_framework_1.TableSummary,
            TableSummaryIntro: bmk_ui_framework_2.TableSummaryIntro,
            TableSummaryActions: bmk_ui_framework_3.TableSummaryActions,
            Search: bmk_ui_framework_8.Search,
            TabsSet: bmk_ui_framework_4.TabsSet,
            TabsSetItem: bmk_ui_framework_5.TabsSetItem,
            ActionsSet: bmk_ui_framework_6.ActionsSet,
            ActionsSetItem: bmk_ui_framework_7.ActionsSetItem,
            AddUserIcon: bmk_ui_framework_9.AddUserIcon,
            BMKIcon: bmk_ui_framework_10.BMKIcon,
            User: lucide_vue_next_1.User,
            Zap: lucide_vue_next_1.Zap,
            Dropdown: floating_vue_1.Dropdown,
        },
    })
], TableSummaryTrialsDetails);
exports.default = TableSummaryTrialsDetails;
